export type RegisterAccountType = 'company' | 'self_employed' | 'annual' | '';

export type RegisterForm = {
  accountType: RegisterAccountType;
  name: string;
  email: string;
  nif: string;
  password: string;
  confirmPassword: string;
  agreeTerms: boolean;
  marketing: boolean;
};

export const emptyRegisterForm = (): RegisterForm => ({
  accountType: '',
  name: '',
  email: '',
  nif: '',
  password: '',
  confirmPassword: '',
  agreeTerms: false,
  marketing: false,
});
